import { Outlet } from "react-router-dom";

import { ErrorBoundary } from "@/components/error-boundary";
import { Toaster } from "@/components/ui/toaster";

/**
 * Header-less layout for public-facing routes (e.g. /preview/:username).
 * Skips the Link session bootstrap because public previews don't require
 * authentication and we don't want anonymous visitors to see admin chrome.
 */
export function BareLayout() {
  return (
    <div className="min-h-screen bg-white">
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      <Toaster />
    </div>
  );
}
